<template lang="pug">
b-form-select.text-uppercase(
  :value="value"
  :size="size"
  :class="{ 'is-invalid': dirty == true && error == true, 'is-valid': dirty == true && error == false }"
  @input="handleInput"
)
  option(value="" :disabled="isDisabled" selected) 
    template(v-if="isDisabled") {{ $t("message.select_option") }}
    template(v-else) {{ $t("ui.all") }}
  option(v-for="option in options" :value="option.value") {{ option.text }}
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "md"
    },
    dirty: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
  },
  data: () => ({
    options: [
      {
        value: "pixel",
        text: "pixel"
      },
      {
        value: "appsflyer",
        text: "appsflyer"
      },
      {
        value: "propeller",
        text: "propeller"
      },
      {
        value: "gtm",
        text: "gtm"
      },
      {
        value: "tiktok",
        text: "tiktok"
      }
    ]
  }),
  methods: {
    handleInput(e) {
      this.$emit("input", e);
    }
  }
};
</script>
